module.exports = __webpack_public_path__ + "static/media/loading.3d341100.gif";